import { connect } from "react-redux";
import { RootState } from "types/store";

import RawPacketsPage from "./RawPacketsPage";

const mapState = ({ rawPackets }: RootState) => ({
    initFilters: rawPackets.filters
});

export default connect(mapState)(RawPacketsPage); 